import { ServiceUrlsService } from '../../common-service/service-urls/service-urls.service';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../../common-service/local-storage/local-storage.service';


@Injectable()
export class SignupService {

  constructor(private httpClient: HttpClient,
              private apiServiceUrls: ServiceUrlsService,
              private localStorageService: LocalStorageService) { }

  private headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});


  signup(signupFormData): Observable<any> {
      return this.httpClient.post(this.apiServiceUrls.signupServiceUrl, signupFormData);
  }

  resendVerificationEmail(verificationEmailObject) : Observable<any> {
      return this.httpClient.post(this.apiServiceUrls.resendVerificationServiceUrl, verificationEmailObject);
  }

  sendSupportEmail(supportEmailObject) : Observable<any> {
      return this.httpClient.post(this.apiServiceUrls.sendSupportEmailUrl, supportEmailObject);
  }

   getMsAccessToken(msSignupEmail) : Observable<any> {

      return this.httpClient.get(this.apiServiceUrls.msAccessTokenUrl + '/'+msSignupEmail);

  }

  sendAzureADInvitation(adInvitationRequestObject) : Observable<any> {

    console.log(adInvitationRequestObject);

    console.log(adInvitationRequestObject);

    console.log(this.localStorageService.getMSAccessToken());

    let headers= new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': this.localStorageService.getMSAccessToken()
            });

      return this.httpClient.post(this.apiServiceUrls.msInvitationURL, adInvitationRequestObject, {headers: headers});
  }

}



// WEBPACK FOOTER //
// ./src/app/signup/service/signup.service.ts